var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Online",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M28.62,44.62a2.59,2.59,0,0,1-1.83-.76l-10-10a2.59,2.59,0,0,1,3.66-3.66l8,8,15-17.9a2.59,2.59,0,0,1,4,3.32L30.61,43.7a2.59,2.59,0,0,1-1.87.92Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/online.svg